var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleSlash({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    className: "_dm-svg",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.365 7.996c0-.903-.265-1.739-.721-2.443L4.399 11.79a4.495 4.495 0 002.46.737c2.485 0 4.506-2.029 4.506-4.531zm-8.274 2.476l6.253-6.245a4.422 4.422 0 00-2.485-.754c-2.485 0-4.506 2.029-4.506 4.522 0 .919.273 1.764.737 2.476zM13.22 7.996c0 3.528-2.849 6.386-6.361 6.386S.498 11.525.498 7.996c0-3.52 2.849-6.378 6.361-6.378s6.361 2.857 6.361 6.378z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleSlash);
export default __webpack_public_path__ + "static/media/CircleSlash.ba40c49799f34f7650585cbbf948a798.svg";
export { ForwardRef as ReactComponent };